module.exports = __webpack_public_path__ + "img/picaud.909687ad.jpg";